import React, { useEffect } from "react";
import Datas from "../data/footer/footer2.json";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import './FooterTwo.css';
import { Styles } from "./styles/footerTwo.js";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import UserService from "../services/UserService";
import { BsTwitterX } from "react-icons/bs";


const languages = [
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
];

function FooterTwo() {
  useEffect(() => {
    UserService.generateToken();
  }, []);

  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const { t } = useTranslation();
  useEffect(() => {
    document.body.dir = currentLanguage.dir || "ltr";
    document.title = t("app_title");
  }, [currentLanguage, t]);

  useEffect(() => {
    const form = document.getElementById("form4");
    const email = document.getElementById("email4");

    // form.addEventListener("submit", formSubmit);

    function formSubmit(e) {
      e.preventDefault();

      const emailValue = email.value.trim();

      if (emailValue === "") {
        setError(email, t("email_error1"));
      } else if (!isEmail(emailValue)) {
        setError(email, t("email_error2"));
      } else {
        setSuccess(email);
      }
    }

    function setError(input, message) {
      const formControl = input.parentElement;
      const errorMsg = formControl.querySelector(".input-msg4");
      formControl.className = "form-control error";
      errorMsg.innerText = message;
    }

    function setSuccess(input) {
      const formControl = input.parentElement;
      formControl.className = "form-control success";
    }

    function isEmail(email) {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
    }
  });

  return (
    <Styles>
      <footer
        className="footer2"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${Datas.backgroundImage})`,
        }}
      >
        <Container>
          <Row>
            <Col md="6">
              <div className="footer-logo-info">

                <div className="f-row">
                  <Row>
                    <Col sm={1}>
                      <i
                        className="f-icon las la-map-marker la-2x"
                        style={{ paddingTop: "8px" }}
                      ></i>
                    </Col>
                    <Col sm={10}>
                      <p >{t("cdac_full_address")}</p>
                    </Col>
                  </Row>
                </div>

                <div className="f-row">
                  <Row>
                    <Col sm={1}>
                      <i className="f-icon las la-envelope la-2x"></i>
                    </Col>
                    <Col sm={10}>
                      <p>
                        {t("enquiry_us_id")}
                      </p>
                    </Col>
                  </Row>
                </div>

                <div className="f-row">
                  <Row>
                    <Col sm={1}>
                      <i className="f-icon las la-phone la-2x"></i>
                    </Col>
                    <Col sm={10}>
                      <p>
                        {t("call_us_phone")}
                      </p></Col>
                  </Row>
                </div>

              </div>
            </Col>
            <Col md="6">
              <div className="f-links f-row">
                <h4>{t("usefull_links")}</h4>
                    <a href="https://www.nfsu.ac.in/">
                      <p>
                        <i className="las la-angle-right"></i> {t("meghsikshak")}
                      </p>
                    </a>
              </div>
            </Col>
            <Col md="12">
              <div className="copytext-area text-center">
                <p>
                  {t("copyright")} &copy; {new Date().getFullYear()}{" "} <a href='https://nfsu.ac.in/'>National Forensic Sciences University</a> {" "}
                  {t("powerby")}
                  <a href="https://meghsikshak.in/">{t("megh")}</a>{" "}
                  {t("design_develop")}
                  <a href="https://www.cdac.in/">({t("cdac")})</a>
                </p>
                <p>
                </p>
                <ul className="social list-unstyled list-inline">
                  <li className="list-inline-item">
                    <a
                      href="https://www.facebook.com/National-Forensic-Sciences-University-109193664143620"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://twitter.com/NFSU_Official"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                    >
                      <i className="fab fa"><BsTwitterX /></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.instagram.com/nfsu.official"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.youtube.com/@nationalforensicsciencesun710"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                    >
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://in.linkedin.com/school/nfsu"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <BackToTop />
      </footer>
    </Styles>
  );
}

export default FooterTwo;
